/*
 * Copyright (c) 2018 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
 *
 *Description:
*/
export default (function (_ref) {
  var payload = _ref.payload,
      resolve = _ref.resolve,
      reject = _ref.reject;

  if (payload.hasOwnProperty('interdictionViewBean')) {
    payload.InterdictionViewBean = payload.interdictionViewBean;
    delete payload.interdictionViewBean;
  }

  if (payload.hasOwnProperty('InterdictionViewBean') && payload.InterdictionViewBean.showInterdictionContent) {
    reject(payload);
  } else {
    resolve(payload);
  }
});